"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)("[data-show-related]", this).each(function (i, item) {
        var $item = (0, _jquery2.default)(item);
        var related = (0, _jquery2.default)($item.attr("data-show-related"));
        if (related.data("ls-show-related") == undefined) {
            related.data("ls-show-related", {
                targets: []
            });
            related.change(onRelatedChange);
        }
        var data = related.data("ls-show-related");
        var showValues = $item.data("show-related-value");
        if (!_jquery2.default.isArray(showValues)) {
            showValues = [($item.attr("data-show-related-value") || "").toLowerCase()];
        }
        var settings = $item.data("show-settings") || {};
        settings = _jquery2.default.extend({}, { negate: false }, settings);
        data.targets.push({ item: $item, values: showValues, settings: settings });
        var val = (related.val() || "").toLowerCase();
        if (related.is(":checkbox,:radio") && !related.is(":checked")) {
            val = "";
        }
        var rv = false;
        for (var k = 0; k < showValues.length; k++) {
            if (val == showValues[k]) {
                rv = true;
                break;
            }
        }
        if (settings.negate) {
            rv = !rv;
        }
        $item[rv ? "show" : "hide"]();
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onRelatedChange() {
    var $this = (0, _jquery2.default)(this);
    var val = ($this.val() || "").toLowerCase();
    if ($this.is(":checkbox,:radio") && !$this.is(":checked")) {
        val = "";
    }
    var relateds = $this.data("ls-show-related").targets;
    (0, _forEach2.default)(relateds, function (related) {
        var rv = false;
        for (var k = 0; k < related.values.length; k++) {
            if (val == related.values[k]) {
                rv = true;
                break;
            }
        }
        if (related.settings.negate) {
            rv = !rv;
        }
        related.item[rv ? "show" : "hide"]();
    });
    for (var j = 0; j < relateds.length; j++) {
        var related = relateds[j];
        var rv = false;
        for (var k = 0; k < related.values.length; k++) {
            if (val == related.values[k]) {
                rv = true;
                break;
            }
        }
        if (related.settings.negate) {
            rv = !rv;
        }
        related.item[rv ? "show" : "hide"]();
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/initializers/show-related.js
// module id = 500
// module chunks = 0